import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ServiceModule } from '../service/service.module';
import { MaterialModule } from './../common/material/material.module';
import { WestnetzModule } from './../common/westnetz/westnetz.module';
import { UniqueEicnummerDirective } from './directives/unique-eicnummer.directive';
import { UniqueNameDirective } from './directives/unique-name.directive';
import { ValidEmailListDirective } from './directives/valid-email-list.directive';
import { KontaktdatenComponent } from './kontaktdaten/kontaktdaten.component';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';
import { NetzbetreiberPageComponent } from './netzbetreiber-page/netzbetreiber-page.component';
import { NetzbetreiberListComponent } from './netzbetreiber-list/netzbetreiber-list.component';
import { UniqueStromNetzbetreiberNummerDirective } from './directives/unique-stromnetzbetreibernummer.directive';
import { UniqueValueDirective } from './directives/unique-value.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        RouterModule,
        WestnetzModule,
        ServiceModule,
    ],
    exports: [
        KontaktdatenComponent,
    ],
    declarations: [
        NetzbetreiberListComponent,
        NetzbetreiberDetailComponent,
        NetzbetreiberPageComponent,
        UniqueNameDirective,
        UniqueEicnummerDirective,
        UniqueStromNetzbetreiberNummerDirective,
        KontaktdatenComponent,
        ValidEmailListDirective,
        UniqueValueDirective,
    ],
})
export class NetzbetreiberModule { }
